import axios from 'axios'
import api from '@/api';

export const screenSaversModule = {
    namespaced: true,

    state:() => ({
        points_of_sale: null,
    }),

    actions: {
        async getPointOfSale({}) {
            return axios
            .get(api + "projects/tcode/shops/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].label = response.data[i].name
                    response.data[i].value = response.data[i].code
                }

                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async fetchScreens({}, query) {
            return axios
            .get(`${api}projects/${query.project}/shops/${query.shop}/media/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async fetchCurrentScreens({}, data) {
            return axios
            .get(`${api}projects/${data.query.project}/shops/${data.query.shop}/media/${data.id}`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }
}